import { ReportTypeEnum } from "../Enums/ReportTypeEnum";
import { submitRetailMatchResults } from "./RetailMatchActions";
import { loadGPSInsightsSuccess } from "./GPSInsightsActions";
import { IShareAxios } from "../Contracts/IShareAxios";
import { ShareAxios } from "../Contracts/Axios/ShareAxios";
import { notification } from "antd";
import { IGPSGetJobResultParsed } from "../Models/IGPSData";

export const getSharedReportByGuid = (guid: string) => {
    const reportType: string = guid.substr(0, guid.indexOf("_"));

    return async (dispatch: any) => {
        const shareAxios: IShareAxios = new ShareAxios();
        try {
            const data: any = await shareAxios.GetSharedReportByGuid(
                reportType,
                guid
            );

            switch (reportType) {
                case ReportTypeEnum.RetailMatch:
                    submitRetailMatchResults(data.data, dispatch);
                    break;

                case ReportTypeEnum.Mobilytics:
                    const polygons = [data.data.job[0].jobPolygon];
                    if (data.data.job.length > 1)
                        polygons.push(data.data.job[1].jobPolygon);
                    const parsedData: IGPSGetJobResultParsed = {
                        polygon: polygons,
                        data: data.data.chartData,
                        job: data.data.job,
                        benchmarkCommonData: data.data.benchmarkCommonData,
                    };

                    dispatch(loadGPSInsightsSuccess(parsedData));
                    break;

                default:
                    return;
            }
        } catch (err) {
            notification.error({
                message: "Error getting Shared Content",
                description: `There was a problem while retrieving the requested shared content: ${err.message}.`,
                duration: null,
            });
        }
    };
};
